/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Managed_By_OidcInputs */

const en_adm_err_managed_by_oidc = /** @type {(inputs: Adm_Err_Managed_By_OidcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This membership comes from single sign-on. Change it in your identity provider.`)
};

const de_adm_err_managed_by_oidc = /** @type {(inputs: Adm_Err_Managed_By_OidcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Mitgliedschaft kommt aus dem Single Sign-on. Ändere sie in deinem Identitätsanbieter.`)
};

/**
* | output |
* | --- |
* | "This membership comes from single sign-on. Change it in your identity provider." |
*
* @param {Adm_Err_Managed_By_OidcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_managed_by_oidc = /** @type {((inputs?: Adm_Err_Managed_By_OidcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Managed_By_OidcInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_managed_by_oidc(inputs)
	return en_adm_err_managed_by_oidc(inputs)
});